class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

 document.addEventListener('click', function (e) {
  const button = e.target.closest('.add-to-cart');

  if (!button) return;
  e.preventDefault();

  if (button.classList.contains('disable')) return;

  const get_id = e.target.closest('.product-form').querySelector('input[name="id"]').value;
  const get_quantity = parseInt(e.target.closest('.product-form').querySelector('input[name="quantity"]').value);
  const items = [{ id: get_id, quantity: get_quantity }];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ items }),
  })
    .then(res => res.text())
    .then(() => {

      document.querySelector('#CartDrawer').classList.add('open');

      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(res => res.json())
        .then(data => {
                  const cartHTML = data['cart-drawer'];
                  if (cartHTML) {
                    const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
                    const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

                    if (newInner) {
                      document.querySelector('#CartDrawer').innerHTML = newInner;
                    }
                  }
                   fetch('/cart.js')
                  .then((res) => res.json())
                  .then((cart) => {

                    let bubbles = document.querySelectorAll('.cart-count');
                    if (bubbles.length === 0) {
                      const bubbleDiv = document.createElement('div');
                      bubbleDiv.className = 'cart-count';
                      bubbleDiv.setAttribute('aria-live', 'polite');
                      bubbleDiv.setAttribute('aria-atomic', 'true');
                      bubbleDiv.setAttribute('id', 'cart-icon-bubble');
                      bubbleDiv.innerHTML = `
                        <span aria-hidden="true">${cart.item_count}</span>
                        <span class="visually-hidden">${cart.item_count} items</span>
                      `;
                      const cartIcons = document.querySelector('[data-cart-drawer-open]');
                      if (cartIcons) {
                        cartIcons.appendChild(bubbleDiv.cloneNode(true));
                      } else {
                        document.body.appendChild(bubbleDiv);
                      }
                      if (cart.item_count > 9) {
                        bubbleDiv.classList.add('double_bubble');
                      }
                    } else {
                      bubbles.forEach((bubble) => {
                        const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
                        const hiddenSpan = bubble.querySelector('.visually-hidden');
                        if (visibleSpan) visibleSpan.textContent = cart.item_count;
                        if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;
                        if (cart.item_count > 9) {
                          bubble.classList.add('double_bubble');
                        }
                      });
                    }
                    if(cart.item_count == 0){
                      document.querySelector('.cart-count').style.display = 'none';
                    }else{
                      document.querySelector('.cart-count').style.display = 'block';
                    }
                  })
                  .catch((err) => {
                    console.error('Failed to update cart drawer section:', err);
                    clearInterval(intervalId);
                  });
          // Now open drawer
          // document.querySelector('#CartDrawer').classList.add('open');
        });
    })
    .catch(err => console.error('Error adding products:', err));
});

 document.addEventListener('click', function (e) {
    const button = e.target.closest('[data-cart-drawer-open]');
    if (!button) return;
    e.preventDefault();
    // Now open drawer
    document.querySelector('#CartDrawer').classList.add('open');
    document.body.classList.add('overflow');
 })
 document.addEventListener('click', function (e) {
    const button = e.target.closest('.cart-drawer__close');
    if (!button) return;
    e.preventDefault();
    // Now open drawer
    document.querySelector('#CartDrawer').classList.remove('open');
    document.body.classList.remove('overflow');
 })
 document.addEventListener('click', function (e) {
    const button = e.target.closest('.cart-drawer__overlay');
    if (!button) return;
    e.preventDefault();
    // Now open drawer
    document.querySelector('#CartDrawer').classList.remove('open');
    document.body.classList.remove('overflow');
 })


//  Remove Button
document.addEventListener('click', function (e) {

const button = e.target.closest('.remove-btn');
if (!button) return;
e.preventDefault();

if (button.classList.contains('disabled_btn')) return;
const itemEl = e.target.closest('.cart-drawer__item');
const get_id = itemEl?.getAttribute('data-id');
if (!get_id) return;

const items = [{ id: get_id, quantity: 0 }];

fetch('/cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  body: JSON.stringify({
        id: get_id,
        quantity: 0
      }),
})
  .then((res) => res.text())
  .then(() => {
    // Fetch updated cart drawer section
    if(document.body.classList.contains('template_cart')){
        fetch(window.location.pathname + '?sections=cart')
          .then((res) => res.json())
          .then((data_add) => {
            const cartHTML = data_add['cart'];
            console.log(data_add,'cartHTMLcartHTML');
            if (cartHTML) {
              const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
              const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

              if (newInner) {
                document.querySelector('#CartDrawer').innerHTML = newInner;
              }
            }
          });
    }else{
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then((res) => res.json())
        .then((data) => {
          const cartHTML = data['cart-drawer'];

          if (cartHTML) {
            const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
            const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

            if (newInner) {
              document.querySelector('#CartDrawer').innerHTML = newInner;
            }
          }
        });
      }
      // Re-open drawer
        document.querySelector('#CartDrawer')?.classList.add('open');
        document.body.classList.remove('overflow');
      // Update cart bubble
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            let bubbles = document.querySelectorAll('.cart-count');

            if (bubbles.length === 0) {
              const bubbleDiv = document.createElement('div');
              bubbleDiv.className = 'cart-count';
              bubbleDiv.id = 'cart-icon-bubble';
              bubbleDiv.setAttribute('aria-live', 'polite');
              bubbleDiv.setAttribute('aria-atomic', 'true');

              bubbleDiv.innerHTML = `
                <span aria-hidden="true">${cart.item_count}</span>
                <span class="visually-hidden">${cart.item_count} items</span>
              `;

              const cartIcons = document.querySelector('[data-cart-drawer-open]');
              if (cartIcons) {
                cartIcons.appendChild(bubbleDiv.cloneNode(true));
              } else {
                document.body.appendChild(bubbleDiv);
              }

              if (cart.item_count > 9) {
                bubbleDiv.classList.add('double_bubble');
              }
            } else {
              bubbles.forEach((bubble) => {
                const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
                const hiddenSpan = bubble.querySelector('.visually-hidden');

                if (visibleSpan) visibleSpan.textContent = cart.item_count;
                if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;

                if (cart.item_count > 9) {
                  bubble.classList.add('double_bubble');
                } else {
                  bubble.classList.remove('double_bubble');
                }
              });
            }
            if(cart.item_count == 0){
              document.querySelector('.cart-count').style.display = 'none';
            }else{
              document.querySelector('.cart-count').style.display = 'block';
            }
          })
          .catch((err) => {
            console.error('Failed to update cart count:', err);
          });

  })
  .catch((err) => console.error('Error removing product:', err));
});


// Quantity Click
document.body.addEventListener("click", function (e) {
  const btn = e.target.closest(".quantity__button");

  if (!btn) return;
  e.preventDefault();

  const wrapper = btn.closest(".quantity");
  if (!wrapper) return;

  const input = wrapper.querySelector(".quantity__input");
  if (!input) return;

  //const min = parseInt(input.dataset.min) || 1;
  //const max = parseInt(input.dataset.max) || Infinity;

  const min = parseInt(input.min) || 1;
  let max = parseInt(input.max);

  if (isNaN(max) || max <= 0) {
    max = Infinity;
  }

  let current = parseInt(input.value) || min;

  // increase / decrease
  if (btn.classList.contains("plus") || btn.dataset.action === "plus") {
    if (current < max) {
       console.log(current,'oooooooooooooooo')
      current += 1;
    }
  }

  if (btn.classList.contains("minus") || btn.dataset.action === "minus") {
    if (current > min) {
      current -= 1;
    }
  }

  input.value = current;

  const plusBtn = wrapper.querySelector(".quantity__button.plus");
  if (plusBtn) {
    if (current >= max) {
      plusBtn.disabled = true;
      plusBtn.classList.add("disabled");
    } else {
      plusBtn.disabled = false;
      plusBtn.classList.remove("disabled");
    }
  }

  if(btn.closest('#CartDrawer') !== null){
    // Update cart qty
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: btn.closest('.cart-drawer__item').getAttribute("data-id"),
        quantity: current
      }),
    })
      .then(r => r.text())
      .then(text => JSON.parse(text))
      .then(data => {

        // If on cart page
        
        if (document.body.classList.contains('template_cart')) {
        
          fetch(window.location.pathname + '?sections=cart')
            .then((res) => res.json())
            .then((data_add) => {
              const cartHTML = data_add['cart'];
              console.log(data_add,'cartHTMLcartHTML');
              if (cartHTML) {
                const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
                const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

                if (newInner) {
                  document.querySelector('#CartDrawer').innerHTML = newInner;
                }
              }
            });

        } else {
          fetch(window.location.pathname + '?sections=cart-drawer')
            .then((res) => res.json())
            .then((data) => {
              const cartHTML = data['cart-drawer'];

              if (cartHTML) {
                const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
                const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

                if (newInner) {
                  document.querySelector('#CartDrawer').innerHTML = newInner;
                }
              }
            });
        }

        // Re-open drawer
        document.querySelector('#CartDrawer')?.classList.add('open');
        document.body.classList.remove('overflow');

        // Update cart bubble
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            let bubbles = document.querySelectorAll('.cart-count');

            if (bubbles.length === 0) {
              const bubbleDiv = document.createElement('div');
              bubbleDiv.className = 'cart-count';
              bubbleDiv.id = 'cart-icon-bubble';
              bubbleDiv.setAttribute('aria-live', 'polite');
              bubbleDiv.setAttribute('aria-atomic', 'true');

              bubbleDiv.innerHTML = `
                  <span aria-hidden="true">${cart.item_count}</span>
                  <span class="visually-hidden">${cart.item_count} items</span>
                `;

              const cartIcons = document.querySelector('[data-cart-drawer-open]');
              if (cartIcons) {
                cartIcons.appendChild(bubbleDiv.cloneNode(true));
              } else {
                document.body.appendChild(bubbleDiv);
              }

              if (cart.item_count > 9) {
                bubbleDiv.classList.add('double_bubble');
              }
            } else {
              bubbles.forEach((bubble) => {
                const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
                const hiddenSpan = bubble.querySelector('.visually-hidden');

                if (visibleSpan) visibleSpan.textContent = cart.item_count;
                if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;

                if (cart.item_count > 9) {
                  bubble.classList.add('double_bubble');
                } else {
                  bubble.classList.remove('double_bubble');
                }
              });
            }
            if(cart.item_count == 0){
              document.querySelector('.cart-count').style.display = 'none';
            }else{
              document.querySelector('.cart-count').style.display = 'block';
            }
          })
          .catch(err => console.error("Cart update error:", err));

      }) // ← Missing before
      .catch(err => console.error("Fetch error:", err)); 
  }
}); 

  // Run on load and resize
  // window.addEventListener('load', handleEqualHeights);
  // window.addEventListener('resize', handleEqualHeights);

// document.addEventListener("DOMContentLoaded", () => {
//   const mainBtn = document.querySelector('.main_add_to_cart:not(.mobile_only)');
//   const mobileBtn = document.querySelector('.main_add_to_cart.mobile_only');

//   if (!mainBtn || !mobileBtn) return;

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         // Main button IS visible → hide mobile button
//         mobileBtn.style.display = "none";
//       } else {
//         // Main button is NOT visible → show mobile button
//         mobileBtn.style.display = "flex";
//       }
//     });
//   }, { threshold: 0 });

//   observer.observe(mainBtn);
// });

// search input typewriter effect-----------------

document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('SearchInput');
  if (!input) return;

  const prefix = 'Search for ';
 const words = [
  'Kids Play Tent',
  'Princess Play Tent',
  'Rocket Tent',
  'Indoor Play Tent',
  'Camping Tent for Kids'
];

  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  function typeEffect() {
    const currentWord = words[wordIndex];

    if (!isDeleting) {
      charIndex++;
    } else {
      charIndex--;
    }

    input.placeholder = prefix + currentWord.substring(0, charIndex);

    let speed = isDeleting ? 50 : 80;

    if (!isDeleting && charIndex === currentWord.length) {
      speed = 500; // pause after full word
      isDeleting = true;
    } 
    else if (isDeleting && charIndex === 0) {
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
      speed = 200;
    }

    setTimeout(typeEffect, speed);
  }

  typeEffect();
});

// end search input typewriter effect-----------------
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}
function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
console.log(value,'innnnnnnnnnnnnnnnnnnn 0000000000');
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantSelectsGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
console.log(value,'innnnnnnnnnnnnnnnnnnn 0000000000');
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects-gallery', VariantSelectsGallery);


if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        // this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          // this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            console.log(source,'source');
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          // this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          // this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          // this.productForm?.toggleSubmitButton(
          //   html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
          //   window.variantStrings.soldOut
          // );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        // this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}


if (!customElements.get('product-info-gallery')) {
  customElements.define(
    'product-info-gallery',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info-gallery:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        // this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info-gallery[id^='MainProduct']" : 'product-info-gallery';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info-gallery'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects-gallery [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects-gallery');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          // this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            console.log(source,'source');
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          // this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          // this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          // this.productForm?.toggleSubmitButton(
          //   html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
          //   window.variantStrings.soldOut
          // );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        // this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects-gallery');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}





// Quick View
document.addEventListener("click", function(e) {
    const btn = e.target.closest(".collection_btn");
    if (!btn) return;

    e.preventDefault();
    const handle = btn.dataset.handle;
    if (!handle) return;
    document.querySelector(".quick-view").classList.add("active");
            document.body.classList.add('overeflow_hidden');
    fetch("/products/" + handle)
        .then(response => response.text())
        .then(data => {
            // Convert string HTML into DOM
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");

            // Get product content (update selector if needed)
            const productContent = doc.querySelector("product-info");

            const container = document.querySelector(".quick-view .wrp_quick_view");

            // ✅ Clear old content
            container.innerHTML = "";

            // ✅ Append new content
            if (productContent) {
                container.appendChild(productContent);
            }

            
             var thumbSwiper = new Swiper('.thumbSwiper', {
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesProgress: true,
              });

              var mainSwiper = new Swiper('.mainSwiper', {
                spaceBetween: 10,
                slidesPerView: 1,
                loop: true,
                thumbs: {
                  swiper: thumbSwiper,
                }
              });
        })
        .catch(err => console.error("Error loading product:", err));
});
document.addEventListener("click", function(e) {
    const btn = e.target.closest(".close_btn_popup");
    if (!btn) return;
    e.preventDefault();
    document.querySelector(".quick-view").classList.remove("active");
    document.body.classList.remove('overeflow_hidden');

})